<template>
  <div>
    <slot/>
    <v-data-table :headers="headers" :items="files" must-sort hide-actions item-key="id" :loading="loading">
      <template slot="items" slot-scope="file">
        <tr>
          <td style="word-wrap: break-word;">
            <v-icon style="cursor:pointer" @click.prevent="deleteFile(file.item.id)" v-if="mutable">cancel</v-icon>
            <v-icon style="cursor:pointer" @click.prevent="downloadFile(file.item.id)">file_download</v-icon>
            {{ file.item.description }}
          </td>
          <td style="line-height: 1em; color: #888;">
            <small>{{ file.item.filename }}</small><br/>
            <small>{{ file.item.filesize | filesize }}</small>
          </td>
          <td style="line-height: 1em; color: #888; word-wrap: break-word;">
            {{ getDocLabel(file.item.documentType) }}
          </td>
          <td>
            {{ fileVisibilityLabel(file.item.visibility) }}
          </td>
        </tr>
      </template>
      <template slot="no-data">
        {{ loading ? '' : '(No files)' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import { fileVisibilityLabel, fileDocTypeLabel } from '../../utils/PfxUtils.js'

  export default {
    name: 'FileList',
    props: {
      auctionId: {
        type: Number,
        required: true
      },
      files: {
        type: Array,
        required: true
      },
      mutable: {
        type: Boolean,
        required: true
      },
      deleteCallback: {
        type: Function,
        required: false,
        default: () => {}
      },
      loading: {
        type: Boolean,
        required: false,
        default: () => false
      }
    },
    data() {
      return {
        fileVisibilityLabel,
        fileDocTypeLabel,
        buyerRequirementOptions: [],
        headers: [
          { text: 'Description', align: 'left', sortable: true, value: 'description' },
          { text: 'Filename / Size', align: 'left', sortable: true, value: 'filename' },
          { text: 'Document Type', align: 'left', sortable: true, value: 'documentType' },
          { text: 'Visibility', align: 'left', sortable: true, value: 'visibility' }
        ]
      }
    },
    computed: {
      ...mapGetters(['subdomain'])
    },
    created() {
      this.$PfxBackendApi.getBuyerRequirementsOptions().then(res => {
          // console.log('getBuyerRequirementsOptions res', res)
          res.data.forEach(document => {
            let item = { text: document.name, id: document.id }
            this.buyerRequirementOptions.push(item)
          })
          console.log('getBuyerRequirementsOptions Array: ', this.buyerRequirementOptions)
        }).catch(err => {
          console.error('getBuyerRequirementsOptions err', err)
        })
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner'
      ]),
      downloadFile(fileId) {
        const anotherWindow = window.open('', '_blank')
        this.$PfxBackendApi
          .initiateFileDownload(
            this.subdomain,
            this.auctionId,
            fileId
          )
          .then(res => {
            anotherWindow.location.href = res.data.url
          })
          .catch(err => {
            anotherWindow.close()
            console.error('initiateFileDownload err', err)
            this.$notify({ type: 'danger', message: 'Cannot initiate the file download' })
          })
      },
      deleteFile(fileId) {
        this.setLoadingSpinner(true)
        this.$PfxBackendApi.deleteFile(this.auctionId, fileId).then((res) => {
          console.log('deleteFile res', res)
          this.deleteCallback(fileId)
        }).catch(err => {
          console.error('deleteFile err', err)
          this.$notify({ type: 'danger', message: 'Cannot delete the file' })
        }).then(() => {
          this.setLoadingSpinner(false)
        })
      },
      getDocLabel(id){
        return fileDocTypeLabel(id, this.buyerRequirementOptions)
      }
    }
  }
</script>

<style lang="scss">

  .theme--light .table { // makes vuetify data-table background transparent
    background-color: rgba(#fff, 0);
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/FileList.vue